import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
// tslint:disable:max-line-length
import React from 'react';
export var DatatypeNumeric = function DatatypeNumeric(props) {
  var _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Numeric' : _props$ariaLabel,
      remProps = _objectWithoutProperties(props, ["ariaLabel"]);

  return React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    "aria-label": ariaLabel
  }, remProps), React.createElement("path", {
    d: "M.08,9.48H1.32V3.12a2.22,2.22,0,0,1-1.23.44V2a1.59,1.59,0,0,0,1.27-.62H3.07v8.1H4.18V11H.08Z"
  }), React.createElement("path", {
    d: "M4.72,10.79c0-4.64,3.42-4.3,3.42-7,0-.7-.24-1-.74-1s-.8.26-1,1.52L4.77,4.08C5,2.35,5.85,1.26,7.53,1.26A2.19,2.19,0,0,1,9.88,3.75c0,3.1-3.2,3.82-3.2,5.73H9.87V11H4.72Z"
  }), React.createElement("path", {
    d: "M10.44,8.58,12,8.32c.19.92.5,1.34,1.06,1.34s1-.45,1-1.48c0-1.28-.42-1.56-1.67-1.56H12V5.21h.49c1.24,0,1.44-.36,1.44-1.4,0-.69-.23-1.05-.81-1.05s-.82.49-1,1.1l-1.52-.35a2.6,2.6,0,0,1,2.64-2.27,2.13,2.13,0,0,1,2.4,2.39,2,2,0,0,1-1.4,2.21c1,.34,1.57,1,1.57,2.53a2.47,2.47,0,0,1-2.69,2.75C11.31,11.12,10.72,10.1,10.44,8.58Z"
  }), React.createElement("rect", {
    y: "13",
    width: "16",
    height: "2"
  }));
};